import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getSitesPage } from '../redux/action/sitesAction.js';
import { Card, CardBody, CardHeader } from '../components/card/card.jsx';
import { openForm } from '../redux/slice/sitesSlice.js';
import ButtonComponent from '../components/ButtonComponent.jsx';
import FormSites from './Sites/FormSites.jsx';
import DataTableComponent from '../components/DatatableComponent.jsx';
import { getRoleModuleById, getRoleModulePage } from '../redux/action/roleModuleAction.js';
import { InputNonForm } from '../components/InputComponent.jsx';
import { useLocation } from 'react-router-dom';
import findItem from '../helperFindPath.js';


const $ = require('jquery');

const Sites = () => {
  const { dataSites, state, idSites, isModal } = useSelector( (state) => state.sites );
  const { dataRoleModule } = useSelector((state) => state.roleModule);
  // console.log(dataRoleModule)
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [page, setPage] = useState(0)
  const [sort, setSort] = useState('')
  const [select, setSelect] = useState('')
  const [filter, setFilter] = useState(([
    { siteName: '' },
  ]))
  const countPerPage = 10
  const param = {
      token: user.access_token,
      sort: sort,
      size: countPerPage,
      select: select,
      filter: filter,
      page: page,
  }
  const resetFilter = () => {
    setFilter([{ siteName: '' }])
  }
  const onChange = async (e, field) => {
    // console.log(e.target.value)
    let arr = [...filter]
    if (field === 'siteName') {
      arr[0].siteName = e.target.value.toUpperCase()
    }
    setFilter(arr)
    // console.log(filter)
  }
  const columns = [
      // {
      //   name: 'ID',
      //   selector: (row) => row.siteId,
      //   sortable: true,
      // },
      // {
      //   name: 'Nama ',
      //   selector: (row) => row.siteName,
      //   sortable: true,
      // },
      {
        name: (
          <div>
            Nama / Lokasi JPO
            <InputNonForm
              type="text"
              value={filter[0].siteName}
              onChange={(e) => onChange(e, 'siteName')}
              style={{ width: '100%' }}
              className="form-control form-control-sm"
            />
          </div>
        ),
        selector: (row) => row.siteName,
      },
      {
        name: 'Alamat JPO',
        selector: (row) => row.siteAddress,
        sortable: true,
      },
      // {
      //   name: 'Latitude',
      //   selector: (row) => row.siteLat,
      //   sortable: true,
      // },
      // {
      //   name: 'Longitude',
      //   selector: (row) => row.siteLon,
      //   sortable: true,
      // },
      {
        name: 'Action',
        cell: (row) => (
          <div style={{ padding: '10px 0' }}>
            {dataByIdRoleModule !== '' ? dataByIdRoleModule.update ? (
            <ButtonComponent
              onClick={(e) =>
                  dispatch(openForm({ state: 'edit', open: true, id: row.siteId, data: row }))
              }
              color="#fff"
              backgroundColor="#3c484f"
              backgroundHover="#db4912"
              >
              <i className="fas fa-pencil-alt" title='Ubah Data JPO' style={{ paddingRight: '5px'}}/> 
            </ButtonComponent>
            ): null : null}
            {dataByIdRoleModule !== '' ? dataByIdRoleModule.delete ? (
            <ButtonComponent
              onClick={(e) =>
                  dispatch(openForm({ state: 'delete', open: true, id: row.siteId, data: row }))
              }
              color="#fff"
              backgroundColor="#3c484f"
              backgroundHover="#db4912"
              >
              <i className="fas fa-trash" title='Hapus Data JPO' />
            </ButtonComponent>
            ): null : null }      
          </div>
        ),
      },
    ]
    
    useEffect(() => {
        dispatch(getRoleModulePage({ roleId: user.user_id , token: param.token}));
    }, []);
    useEffect(() =>{
      dispatch(getSitesPage(param));
    }, [page, filter, select, sort])
    
    const {dataRoleModuleSidebar, dataByIdRoleModule} = useSelector((state)=>state.roleModule)
    const { pathname } = useLocation();
    const [ dataObjPath, setDataObjPath] = useState('')
    useEffect(() => {
      if(dataObjPath !== ''){
        param.id = dataObjPath.id
        dispatch(getRoleModuleById(param))
      }
      // eslint-disable-next-line
    }, [dataObjPath]);
    useEffect(()=>{
      if(dataRoleModuleSidebar.length > 0){
        const findPath = findItem(dataRoleModuleSidebar, pathname)
        // console.log(findPath)
        if(findPath !== null){
          setDataObjPath(findPath) 
        }else{
          setDataObjPath('403')
        }
      }
    },[dataRoleModuleSidebar])
  
    if(dataObjPath === ''){
      return (
        null
      )
    }else if(dataObjPath === '403'){
      return (
        <div>
          <h2>403: Forbidden</h2>
          <p>Anda Tidak Memiliki Hak Akses Untuk Halaman Ini</p>
        </div>
      )
    }else{
      return (
       <div>
            <h4>JPO</h4>
            <div className="row">
                <div className="col-xl-12">
                <Card className="mb-3">
                    <CardHeader style={{ borderBottom: 'none'}}>
                    <div className="row">
                        <div className="col-xl-6">
                          {/* <span style={{ fontSize: '1rem' }}> JPO </span>
                          <span className="text-secondary"> List </span> */}
                        </div>
                        <div className="col-xl-6" style={{ textAlign: 'right', alignSelf: 'center' }}>
                          <ButtonComponent
                            onClick={() => resetFilter()}
                            color="white"
                            backgroundColor="#3003fc"
                            backgroundHover="#2404b5"
                            style={{ marginRight: 5 }}
                          >
                            <i className="fas fa-history"/> Reset
                          </ButtonComponent>
                          {dataByIdRoleModule.create ? (
                            <ButtonComponent
                              onClick={() => dispatch(openForm({ open: true, state: 'add' }))}
                              color="white"
                              backgroundColor="#3003fc"
                              backgroundHover="#2404b5"
                            >
                              + Tambah 
                            </ButtonComponent>
                          ):null}    
                      </div>  
                    </div>
                    </CardHeader>

                    {dataByIdRoleModule.read ? (
                      <CardBody>
                        <DataTableComponent
                            data={dataSites}
                            page={page}
                            countPerPage={countPerPage}
                            columns={columns}
                            setPage={setPage}
                        />
                      </CardBody>
                    ):null}
                </Card>
                </div>
            </div>
            <FormSites param={param}/>
            </div>
      );
    }
  }
    

export default Sites